import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { useEffect } from 'react';

import { type QueryStateSchema, backwardsCompatabilityFactory, queryParam, queryStateParser } from './queryStateParser';

const QS_KEY = 'paneInvoiceId';
const QS_TYPE: QueryStateSchema['type'] = 'invoice';

export const useOpenInvoicePane = (): ((args: { invoiceId: string }) => void) => {
  const [invoiceIdDeprecated, setInvoiceId] = useQueryState(QS_KEY, { history: 'push' });
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  useEffect(() => {
    if (invoiceIdDeprecated) {
      setInvoiceId(null);
      setState(backwardsCompatabilityFactory({ id: invoiceIdDeprecated, type: QS_TYPE }));
    }
  }, [invoiceIdDeprecated]);

  return ({ invoiceId }) => {
    setState((prevState) => [
      ...(prevState || []),
      {
        id: invoiceId,
        key: nanoid(),
        type: QS_TYPE,
      },
    ]);
  };
};
